import React from 'react';

import styles from './ReviewItem.module.css';

type TProps = {
  text: string;
};

export const ReviewItemTitle = ({ text }: TProps) => (
  <div className={styles.ReviewItem__Title}>{text}</div>
);
